export const errorBoundary = {
  emoji: '🤦‍♂️',
  title: '¡Oops! Algo se rompió',
  subtitle: 'Parece que la aplicación se tomó un café de más y ahora está un poco mareada',
  technicalErrorLabel: 'Error técnico (para los nerds):',
  unknownError: 'Error desconocido (¿fantasma en la máquina?)',
  solutionsIntro: 'No te preocupes, estas cosas pasan. Intentá alguna de estas soluciones mágicas:',
  solutions: {
    turnOffOn: 'Apagar y prender (el clásico que nunca falla)',
    pray: 'Rezar a los dioses del código',
    clearCache: 'Limpiar las cookies y caché (porque sí)',
    contactSupport: 'Contactar al equipo de soporte (nosotros también estamos confundidos)',
  },
  buttons: {
    goHome: '🔄 Volver al inicio',
    goBack: '← Volver',
    reload: '♻️ Recargar página',
  },
  footer: 'Si el error persiste, probablemente sea culpa de Mercury en retrógrado 🪐',
  chunk: {
    updating: 'Actualizando a la última versión…',
    title: 'Hay una nueva versión disponible',
    subtitle: 'Actualizamos la aplicación. Recargá la página para continuar.',
    reload: 'Recargar página',
  },
} as const
